import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';

export const useStyles = makeStyles()(theme => ({
  datePickerContainer: {},
  timezoneButton: {
    color: theme.palette.text.secondary,
    textTransform: 'unset',
  },
  buttonIcon: {
    color: theme.palette.text.disabled,
  },
  backgroundGrey: {
    background: grey[200]
  },
  backgroundWhite: {
    background: theme.palette.common.white
  },
  emptySlots: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(5, 1),
    whiteSpace: 'nowrap',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  emptySlotsButton: {
    '& svg': {
      marginTop: '-2px',
      marginLeft: theme.spacing(1)
    }
  },
  slots: {
    backgroundColor: theme.palette.common.white,
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(4, 1fr)',
    padding: theme.spacing(2, 1),
    whiteSpace: 'nowrap'
  },
  timeSlotsRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  triadSlotsRoot: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1, 0, 0),
  },
  triadSlotsContainer: {
    whiteSpace: 'nowrap',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(1),
    '& button': {
      paddingLeft: 0,
      paddingRight: 0
    },
    height: '224px',
    overflow: 'auto',
    padding: theme.spacing(1, 6, 2)
  },
  triadHeight: {
    height: '224px'
  },
  fontWeight500: {
    fontWeight: 500
  },
  fontWeight600: {
    fontWeight: 600
  },
  userSelectNone: {
    userSelect: 'none'
  },
  table: {
    tableLayout: 'fixed',
  },
  tableCell: {
    textAlign: 'center',
    border: 'none',
    padding: theme.spacing(0.75, 0)
  },
  tableButton: {
    width: '28px',
    height: '28px',
    '& > *': {
      lineHeight: 1
    },
    borderRadius: '50%',
    color: theme.palette.text.disabled
  },
  tableButtonHighlighted: {
    background: theme.palette.secondary.background,
    color: theme.palette.text.primary
  },
  tableButtonIsSelected: {
    background: theme.palette.secondary.dark,
    color: theme.palette.secondary.contrastText,
    fontWeight: 500
  }
}));
